import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { url } from "../Constent/Constant";
import { DropzoneArea } from 'material-ui-dropzone';

const Team = ({ Heading, HeadingId, CardData, UpdateImage, UpdateText }) => {
    const [TextUpdate, setTextUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [TextId, setTextId] = useState('')
    const [ImageId, setImageId] = useState('')
    const [HeadingUpdate, setHeadingUpdate] = useState('')

    const showImageModal = (id) => {
        setImageModal(true);
        setImageId(id)
    };

    const showTextModal = (id) => {
        setTextModalVisible(true);
        setTextId(id)
    };

    const TextHandle = () => {
        if (TextUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: TextUpdate,
                id: TextId
            })
            setTextModalVisible(false);
            setTextUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: ImageId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if(event.key === 'Enter'){
          console.log('Enter Clicked')
          a.concat('\n')
          setHeadingUpdate(a)
        }else{
          console.log(event.key)
        }
      }

    return (
        <div className='Team-Container'>
            <h2> {Heading ? Heading : ''}
                <i onClick={() => showTextModal(HeadingId)} className="far fa-edit Edit-btn"></i>
            </h2>
            <div className='Team-Members'>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <img src={`${url}/api/getFile${CardData.card1.img}`} alt='Team Members' draggable='false' />
                        <i onClick={() => showImageModal(CardData.card1.imgId)} className="far fa-edit Edit-btn"></i>
                    </div> */}
                    <h3>{CardData ? CardData.card1.heading : ''}
                        <i onClick={() => showTextModal(CardData.card1.headingId)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <p>{CardData ? CardData.card1.para : ''}
                        <i onClick={() => showTextModal(CardData.card1.paraId)} className="far fa-edit Edit-btn"></i>
                    </p>
                </div>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <img src={`${url}/api/getFile${CardData.card2.img}`} alt='Team Members' draggable='false' />
                        <i onClick={() => showImageModal(CardData.card2.imgId)} className="far fa-edit Edit-btn"></i>
                    </div> */}
                    <h3>{CardData ? CardData.card2.heading : ''}
                        <i onClick={() => showTextModal(CardData.card2.headingId)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <p>{CardData ? CardData.card2.para : ''}
                        <i onClick={() => showTextModal(CardData.card2.paraId)} className="far fa-edit Edit-btn"></i>
                    </p>
                </div>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <img src={`${url}/api/getFile${CardData.card3.img}`} alt='Team Members' draggable='false' />
                        <i onClick={() => showImageModal(CardData.card3.imgId)} className="far fa-edit Edit-btn"></i>
                    </div> */}
                    <h3>{CardData ? CardData.card3.heading : ''}
                        <i onClick={() => showTextModal(CardData.card3.headingId)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <p>{CardData ? CardData.card3.para : ''}
                        <i onClick={() => showTextModal(CardData.card3.paraId)} className="far fa-edit Edit-btn"></i>
                    </p>
                </div>
            </div>


            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e)=> OnEnterPress(e)} value={TextUpdate} onChange={e => setTextUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>
        </div>
    )
}

export default Team
